import AntiguaFlag from '../UI/AntiguaFlag';

const Footer = () => {
  var year = (new Date()).getFullYear();
  return (
    <footer className="bg-[var(--color-neutral-100)] border-t border-[var(--color-neutral-border)] text-[var(--color-subtext-color)] py-6">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between items-center flex-wrap gap-4">
          <div className="flex items-center gap-2">
            <div className="w-6 h-4 flex-shrink-0">
              <AntiguaFlag width={24} height={16} className="rounded-sm" />
            </div>
            <span className="text-sm font-medium text-[var(--color-default-font)]">
              ANTIGUA & BARBUDA Citizens Portal
            </span>
          </div>
          <p className="text-xs text-[var(--color-subtext-color)]">
            These results inform priority allocation. They do not change law or government authority.
          </p>
          <p className="text-xs text-[var(--color-subtext-color)]">
            &copy; {year} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
